export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800">
      <div className="max-w-[900px] mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Left: Visual */}
          <div className="flex-shrink-0">
            <div className="relative w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-background-50/10 backdrop-blur-sm border border-background-50/20 flex items-center justify-center overflow-hidden">
              <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl bg-background-50">
                <i className="ri-fire-fill text-primary-500 text-4xl md:text-5xl"></i>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
              随时随地 · 掌上吃瓜
            </h2>
            <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-6">
              51吃瓜黑料移动端适配已全面优化，手机浏览器直接访问即可获得流畅的吃瓜体验。
              无需下载任何APP，打开即用，随时随地掌握最新爆料动态。
              收藏本站到手机桌面，一键直达你的专属吃瓜前线。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <div className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-background-50 text-primary-700 font-semibold text-sm cursor-pointer hover:bg-background-100 transition-colors">
                <i className="ri-smartphone-line text-lg"></i>
                <span className="whitespace-nowrap">手机浏览器访问</span>
              </div>
              <div className="inline-flex items-center gap-2 px-5 py-3 rounded-lg border-2 border-background-50/30 text-background-50 font-semibold text-sm cursor-pointer hover:bg-background-50/10 transition-colors">
                <i className="ri-bookmark-line text-lg"></i>
                <span className="whitespace-nowrap">加入收藏夹</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}